<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">

      <!-- Register v1 -->
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <track-helps-logo />
          <h2 class="brand-text text-primary ml-1">
            TrackHelps
          </h2>
        </b-link>

        <b-card-title class="mb-1">
          LINE 會員關係管理系統來囉 🚀
        </b-card-title>
        <b-card-text class="mb-2">
          TrackeHelps 顧客關係管理幫你防疫變獲益！
        </b-card-text>

        <Error-alert
          :error="error"
          :error-show="errorShow"
        />

        <!-- form -->
        <validation-observer
          ref="registerForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-register-form mt-2"
            @submit.prevent="validationForm"
          >
            <!-- Full Name -->
            <b-form-group
              :label="$t('Full Name')"
              label-for="fullName"
            >
              <validation-provider
                #default="{ errors }"
                name="fullName"
                rules="required"
              >
                <b-form-input
                  id="fullName"
                  v-model="fullName"
                  placeholder="Michael Jaren"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- email -->
            <b-form-group
              label="Email"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  :state="errors.length > 0 ? false:null"
                  name="register-email"
                  placeholder="john@example.com"
                  :formatter="formatter"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group
              :label="$t('Password')"
              label-for="password"
            >
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    :state="errors.length > 0 ? false:null"
                    class="form-control-merge"
                    name="register-password"
                    placeholder="············"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      :icon="passwordToggleIcon"
                      class="cursor-pointer"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- checkbox -->
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="privacy-terms"
                rules="required"
              >
                <b-form-checkbox
                  id="register-privacy-policy"
                  v-model="status"
                  name="checkbox-1"
                >
                  {{ $t('I agree to') }}
                  <b-link href="https://trackhelps.com/privacy.html">
                    {{ $t('privacy policy') }}
                  </b-link>
                  <span> & </span>
                  <b-link href="https://trackhelps.com/terms.html">
                    {{ $t('terms') }}
                  </b-link>
                </b-form-checkbox>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              block
              type="submit"
              :disabled="invalid"
            >
              {{ $t('Sign up') }}
            </b-button>
          </b-form>
        </validation-observer>

        <b-card-text class="text-center mt-2">
          <span>{{ $t('Already have an account?') }} </span>
          <b-link :to="{name:'login'}">
            <span>{{ $t('Sign in instead') }}</span>
          </b-link>
        </b-card-text>
      </b-card>
    <!-- /Register v1 -->
    </div>
  </div>

</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BButton, BForm, BFormCheckbox, BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BCardTitle, BCardText,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TrackHelpsLogo from './Logo.vue'
import ErrorAlert from './error/ErrorAlert.vue'

export default {
  components: {
    TrackHelpsLogo,
    BCard,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    // validations
    ValidationProvider,
    ValidationObserver,
    ErrorAlert,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      error: {},
      errorShow: false,
      status: '',
      userEmail: '',
      password: '',
      fullName: '',
      sideImg: require('@/assets/images/pages/register-v2.svg'),
      // validation
      required,
      email,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.registerForm.validate().then(success => {
        if (success) {
          const user = {
            email: this.userEmail,
            password: this.password,
            displayName: this.fullName,
          }

          store.dispatch('signUp', user).then(() => {
            // Clear Error
            this.$data.error = this.$options.data().error
            this.$data.errorShow = this.$options.data().errorShow

            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$t('account created please verify your email'),
                icon: 'CheckIcon',
                variant: 'success',
              },
            },
            {
              position: 'top-center',
              timeout: 8000,
            })
            this.$router.push('login')
          }).catch(err => {
            this.error = err
            this.errorShow = true
          })
        }
      })
    },
    formatter(value) {
      return value.toLowerCase()
    },
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
